import { createTestId } from 'aem-libs-tests/src/utility/createTestId'

import { ResultCtaStyled } from './ResultCta.styled'
import { ResultCtaButton } from './ResultCtaButton'
import { ResultCtaButtonType, ResultSelectItemType } from './types'


export interface ResultCtaProps {
  items: ResultCtaButtonType[]
  testId?: string
}

const mobileBreakpoint = 768

export const showOnDevice = (item: ResultCtaButtonType | ResultSelectItemType) => {
  const isMobile = window.screen.width <= mobileBreakpoint
  if (item.showOnDevice) {
    return isMobile ? item.showOnDevice === 'mobile' : item.showOnDevice === 'desktop'
  }
  return true
}

export const ResultCta = ({ items, testId }: ResultCtaProps) => {
  const usedTestId = testId ?? 'result-cta'

  return (
    <ResultCtaStyled data-testid={createTestId(usedTestId, 'wrapper')}>
      {items
        .filter((buttonItem) => buttonItem.showButton && showOnDevice(buttonItem))
        .sort((a, b) => (a.order ?? 0) - (b.order ?? 0))
        .map((buttonItem, index) => (
          <ResultCtaButton key={index} {...buttonItem} testId={createTestId(usedTestId, buttonItem.type as string)} />
        ))}
    </ResultCtaStyled>
  )
}
